import { SectionSubTitle } from "../../../components/SectionTitle";
import { Spacer } from "../../../components/Spacer";
import { FadeRight } from "../../../components/Transitions/FadeRight";

export const DressCode = () => {
  return (
    <FadeRight>
      <SectionSubTitle title="Dress Code" />

      <Spacer />
      <Spacer />

      <div className="flex flex-col items-center max-w-150 m-auto">
        <div className="z-1">
          <img src="/dresscode.png" alt="dress code" />
        </div>
        <div className="soft-card max-w-150 w-full min-h-30 flex justify-center items-center -mt-10 rounded-4xl px-6">
          <div className="text-primary-text text-xl md:text-2xl opacity-75">
            Formal
          </div>
        </div>
      </div>
    </FadeRight>
  );
};
